// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

// Define a service using a base URL and expected endpoints
export const mocksApi = createApi({
  reducerPath: "mocks",
  baseQuery: encryptedBaseQueryWithReauth(),
  tagTypes: ["getMockList", "mockDetail"],
  endpoints: (builder) => ({
    getMockList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getMockList"],
    }),
    getMockCategory: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getMockCategory"],
    }),
    createMock: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["getMockList"],
    }),

    updateMock: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
      }),
      invalidatesTags: ["mockDetail"],
    }),
    cloneMock: builder.mutation({
      query: ({ endpoint }) => ({
        url: endpoint,
        method: "POST",
        // body: updatedData,
      }),
      invalidatesTags: ["mockDetail"],
    }),


    getMockTest: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getMockList"],
    }),


    getMockPackages: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getMockPackage"],
    }),



    getMockTestDetail: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["mockDetail"],
    }),


    addMockPackage: builder.mutation({
      query: ({ endpoint, newPackage }) => ({
        url: endpoint,
        method: "POST",
        body: newPackage,
      }),
      invalidatesTags: ["getMockPackage"],
    }),

    editMockPackage: builder.mutation({
      query: ({ endpoint, newPackage }) => ({
        url: endpoint,
        method: "PATCH",
        body: newPackage,
      }),
      invalidatesTags: ["getMockPackage"],
    }),

    publish: builder.mutation({
      query: ({ endpoint, updatedData }) => {
        return {
          url: endpoint,
          method: "PATCH",
          body: updatedData,

        };
      },
    }),
    addMockPackageCategory: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addMockPackageCategory"],
    }),
    getMockResetList: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),

    resetMock: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
    }),
    getMockAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
  }),
});

export const {
  useAddMockPackageCategoryMutation,
  useResetMockMutation,
  useGetMockListQuery,
  useGetMockAnalyticsQuery,
  useGetMockResetListQuery,
  useGetMockCategoryQuery,
  usePublishMutation,
  useLazyGetMockListQuery,
  useCreateMockMutation,
  useUpdateMockMutation,
  useCloneMockMutation,
  useGetMockPackagesQuery,
  useAddMockPackageMutation,
  useGetMockTestQuery,
  useGetMockTestDetailQuery,
  useEditMockPackageMutation,

} = mocksApi;
